import type {PermissionsRecordType} from '../permissions';

export const syncedMessagePermissions = {
  syncedMessageRead: {
    resourceId: 'SYNCED_MESSAGE',
    actionId: 'READ',
    scopes: [],
  },
  tenantMailboxRead: {
    resourceId: 'TENANT_MAILBOX',
    actionId: 'READ',
    scopes: [],
  },
  tenantMailboxCreate: {
    resourceId: 'TENANT_MAILBOX',
    actionId: 'CREATE',
    scopes: [],
  },
  tenantMailboxUpdate: {
    resourceId: 'TENANT_MAILBOX',
    actionId: 'UPDATE',
    scopes: [],
  },
  tenantMailboxDelete: {
    resourceId: 'TENANT_MAILBOX',
    actionId: 'DELETE',
    scopes: [],
  },
} satisfies PermissionsRecordType;
